/** Link inside a table or detail row: brand blue, darker on hover, 2px brand focus ring. */
export const textLinkClassName =
    'rounded-sm font-medium text-primary-500 no-underline outline-none hover:text-primary-600 focus-visible:ring-2 focus-visible:ring-ring';

/** Link inside running text: underlined so it does not rely on color alone. */
export const inlineLinkClassName =
    'rounded-sm font-medium text-primary-500 underline underline-offset-2 hover:text-primary-600 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';
